/* tslint:disable */
/* eslint-disable */
/**
 * ClinicManagement API
 * This is an OpenAPI for the Clinic Management Microservice
 *
 * OpenAPI spec version: 0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddUserRequestContact } from './add-user-request-contact';
import { AddUserRequestIdentity } from './add-user-request-identity';
import { AddUserRequestInsurance } from './add-user-request-insurance';
import { EmployeeSignUpEmployeeUserAddress } from './employee-sign-up-employee-user-address';
/**
 * 
 * @export
 * @interface AddUserDoctorRequestUser
 */
export interface AddUserDoctorRequestUser {
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    FirstName: string;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    MiddleName: string;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    FamilyName: string;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    MotherName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    Username: string;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    Password: string;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    PasswordConfirmed: string;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    BloodType: AddUserDoctorRequestUserBloodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    Gender: AddUserDoctorRequestUserGenderEnum;
    /**
     * 
     * @type {Date}
     * @memberof AddUserDoctorRequestUser
     */
    DateOfBirth: Date;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    PhotoURI?: string;
    /**
     * 
     * @type {AddUserRequestContact}
     * @memberof AddUserDoctorRequestUser
     */
    Contact: AddUserRequestContact;
    /**
     * 
     * @type {EmployeeSignUpEmployeeUserAddress}
     * @memberof AddUserDoctorRequestUser
     */
    Address?: EmployeeSignUpEmployeeUserAddress;
    /**
     * 
     * @type {AddUserRequestInsurance}
     * @memberof AddUserDoctorRequestUser
     */
    Insurance?: AddUserRequestInsurance;
    /**
     * 
     * @type {string}
     * @memberof AddUserDoctorRequestUser
     */
    MaritalStatus?: AddUserDoctorRequestUserMaritalStatusEnum;
    /**
     * 
     * @type {AddUserRequestIdentity}
     * @memberof AddUserDoctorRequestUser
     */
    Identity?: AddUserRequestIdentity;
}

/**
    * @export
    * @enum {string}
    */
export enum AddUserDoctorRequestUserBloodTypeEnum {
    A = 'A+',
    A_1 = 'A-',
    AB = 'AB+',
    AB_3 = 'AB-',
    B = 'B+',
    B_5 = 'B-',
    O = 'O+',
    O_7 = 'O-',
    Unknown = 'Unknown'
}
/**
    * @export
    * @enum {string}
    */
export enum AddUserDoctorRequestUserGenderEnum {
    Male = 'Male',
    Female = 'Female',
    Unspecified = 'Unspecified'
}
/**
    * @export
    * @enum {string}
    */
export enum AddUserDoctorRequestUserMaritalStatusEnum {
    Married = 'Married',
    Single = 'Single',
    Divorced = 'Divorced',
    Widowed = 'Widowed',
    Unspecified = 'Unspecified'
}

